import styled from "styled-components";
import logoEYB from '../../images/logo_EYB/logoEYB.png'
import {ErrorMessage, Field, Form, Formik} from "formik";
import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {GreenButton} from "../buttons/ButtonStyles";
import {authVerification} from "./actions/authAction";

const AuthVerificationForm = () => {
    const {email} = useSelector(state => state.currentUser)
    const {isConfirmedStatus} = useSelector(state => state.auth)

    const [isErrors, setIsErrors] = useState(true)

    const dispatch = useDispatch()

    const handleSubmit = (data) => {
        try {
            dispatch(authVerification(data))
        } catch {
            setIsErrors(true)
        }
    }

    const displayErrorMessage = () => {
        if (isConfirmedStatus !== 200 && isConfirmedStatus !== 0 && isErrors) {
            return <p className={"error-text"}> Il semblerait que ce ne soit pas le bon mot de passe </p>
        }
    }
    return (
        <Container>
            <h1> Sécurité </h1>
            <p> Vous êtes en train d'accéder à une section permettant de modifier du contenu sensible. Pour plus de
                sécurité, nous vous demandons d'écrire votre mot de passe. </p>
            <Error>
                {displayErrorMessage()}
            </Error>
            <img src={logoEYB} alt={"logo d'enjoy your business"}/>
            <Formik
                initialValues={{
                    username: email,
                    password: "",
                }}
                onSubmit={handleSubmit}
            >
                {() => (
                    <Form>
                        <Field
                            name="username"
                            type={"text"}
                            placeholder={"email"}
                        />
                        <ErrorMessage
                            name="username"
                            render={msg => <div><p className="error-text"> {msg} </p></div>}
                        />
                        <Field
                            name="password"
                            type={"password"}
                            placeholder={'mot de passe'}

                        />
                        <ErrorMessage
                            name="lastName"
                            render={msg => <div><p className="error-text"> {msg} </p></div>}

                        />
                        <Button type="submit">
                            <h6> Envoyer </h6>
                        </Button>
                    </Form>
                )}
            </Formik>
        </Container>
    )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 2em;
  padding: 0 2rem;

  h1,p {
    align-self: flex-start;
  }

  img {
    width: 100px;
    height: 80px;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    input, select {
      border-radius: 10px;
      padding: 0.5rem;
      border: 1px solid rgba(166, 172, 181, 0.3);
      background-color: #eee;
      outline: none;
      width: 100%;

      &:focus {
        border-color: rgba(51, 148, 246, 1);
      }
    }
  }
`
const Button = styled(GreenButton)``
const Error = styled.div`
  height: 2rem;
`
export default AuthVerificationForm;